import { lifecycle, compose } from 'recompose';
import { NavigationSpec } from '../../states/NavigationState';
import { inject, MobXProviderContext } from 'mobx-react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { useViewportState } from '../../../commonv3/hooks/useViewportState';
import { useContext, useEffect } from 'react';

export const withNavigation = (defaultSpec: NavigationSpec, mobileSpec?: NavigationSpec) =>
    compose(
        inject('navigationState'),
        lifecycle({
            componentDidMount() {
                const spec = mobileSpec ? (GlobalStatesV3.viewport.isDesktop ? defaultSpec : mobileSpec) : defaultSpec;
                this.props.navigationState.setSpec(spec);
            },
        })
    );

export const useNavigation = (defaultSpec: NavigationSpec, mobileSpec?: NavigationSpec) => {
    const { isDesktop } = useViewportState();
    const context = useContext(MobXProviderContext);
    useEffect(
        () => {
            const spec = mobileSpec ? (isDesktop ? defaultSpec : mobileSpec) : defaultSpec;
            context.navigationState.setSpec(spec);
        },
        [isDesktop]
    );
};
